// TODO: after v1 sunset rename `ReportChannels` -> `ReportGroups` (with props)
import * as React from 'react'
import { connect } from 'react-redux'
import type { Group } from 'types/group'
import type { State } from 'types/redux'
import type { DropdownOption } from 'types/ui'
import { updatePlaylistReportParams } from '@disco/state-management/actions/ReportActions'
import ChannelSelector from 'components/common/channel-selector'
type OwnProps = {
  formKey: string
}

function mapStateToProps(state: State, ownProps: OwnProps): any {
  const value: DropdownOption[] =
    state.reports.playlistReport.form[ownProps.formKey]
  return {
    value,
  }
}

function mapDispatchToProps(dispatch: any, ownProps: OwnProps): any {
  return {
    onChannelSelect(value) {
      dispatch(
        updatePlaylistReportParams({
          [ownProps.formKey]: value,
        }),
      )
    },
  }
}

class ReportChannels extends React.Component<{
  channels: Group[]
  placeholder: string
  value: DropdownOption[]
  onChannelSelect: (...args: Array<any>) => any
  disabled?: boolean
}> {
  render() {
    const { channels, placeholder, value, onChannelSelect } = this.props
    return (
      <ChannelSelector
        placeholder={placeholder}
        channels={channels}
        selectedChannels={value}
        onChannelSelect={onChannelSelect}
        disabled={this.props.disabled}
      />
    )
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ReportChannels) as any
